import { render, staticRenderFns } from "./DialogProfileUserAttach.vue?vue&type=template&id=c035d4de&"
import script from "./DialogProfileUserAttach.vue?vue&type=script&lang=js&"
export * from "./DialogProfileUserAttach.vue?vue&type=script&lang=js&"
import style0 from "./DialogProfileUserAttach.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c035d4de')) {
      api.createRecord('c035d4de', component.options)
    } else {
      api.reload('c035d4de', component.options)
    }
    module.hot.accept("./DialogProfileUserAttach.vue?vue&type=template&id=c035d4de&", function () {
      api.rerender('c035d4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogProfileUserAttach.vue"
export default component.exports